import type { IfNodeType } from '@/nodes/types';
import type { GuideNodeId } from '@rock/types';
import { outgoingHandles } from '@rock/types';
import { Handle, type NodeProps, Position } from '@xyflow/react';
import type { FC } from 'react';
import { NodeDataKeyWarningIcon } from './NodeUI';

const IfNode: FC<NodeProps<IfNodeType>> = ({ id, data }) => {
    const paths = outgoingHandles.if(id as GuideNodeId, data);
    return (
        <div className="relative w-[80px] h-[80px]">
            <NodeDataKeyWarningIcon id={id} />
            <div className="w-full h-full flex items-center justify-center transform rotate-45 bg-blue-50 border border-black">
                <div className="transform -rotate-45 flex flex-col items-center">
                    <div className="text-sm font-bold text-blue-900">IF</div>
                    <div className="text-[6pt] text-blue-900">
                        {data.fn ? `${data.fn}(${data.field})` : data.field} {data.op} {data.value}
                    </div>
                </div>
            </div>

            <div className="absolute left-[-15px] top-[50%]">
                <Handle type="target" position={Position.Left} />
            </div>

            <div className="absolute right-[-15px] top-[-5px]">
                <div className="text-[6pt] py-0.5 px-2 border-1 border-black bg-green-100 rounded-sm mr-[1px]">
                    TRUE
                </div>
                <Handle type="source" id={paths.true} position={Position.Right} />
            </div>

            <div className="absolute right-[-15px] bottom-[-5px]">
                <div className="text-[6pt] py-0.5 px-2 border-1 border-black bg-red-100 rounded-sm mr-[1px]">FALSE</div>
                <Handle type="source" id={paths.false} position={Position.Right} />
            </div>
        </div>
    );
};

export default IfNode;
